import { Extension } from '@tiptap/core';

export const TributeEnterHandlerExtension = Extension.create({
  name: 'tributeEnterHandler',

  priority: 150,

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        // Check if Tribute dropdown is active
        const tributeContainer = document.querySelector('.tribute-container');

        if (tributeContainer && tributeContainer instanceof HTMLElement) {
          // Check if the container is visible
          const isVisible = tributeContainer.style.display !== 'none' && tributeContainer.offsetParent !== null;

          if (isVisible) {
            // Find the highlighted item (li element with highlight class)
            const highlightedItem = tributeContainer.querySelector('li.highlight');

            if (highlightedItem && highlightedItem instanceof HTMLElement) {
              // Simulate a click on the highlighted item
              highlightedItem.click();
              return true; // Prevent default Enter behavior
            }
          }
        }

        // If Tribute is not active, allow normal Enter behavior
        return false;
      },
    };
  },
});
